import React from "react";
import { clsx } from "clsx";

type ButtonVariant = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "ghost";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    children: React.ReactNode;
}

export const Button = ({ variant = "primary", size = "md", className, children, disabled, ...props }: ButtonProps): React.ReactElement => {
    const baseClasses =
        "inline-flex items-center justify-center font-medium rounded transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

    const sizeClasses = {
        sm: "px-2 py-1 text-sm",
        md: "px-4 py-2 text-sm",
        lg: "px-6 py-3 text-base"
    };

    const variantClasses = {
        primary: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500",
        secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-500",
        success: "bg-green-600 text-white hover:bg-green-700 focus:ring-green-500",
        danger: "bg-red-500 text-white hover:bg-red-700 focus:ring-red-500",
        warning: "bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-yellow-500",
        info: "bg-cyan-600 text-white hover:bg-cyan-700 focus:ring-cyan-500",
        ghost: "bg-transparent text-gray-700 hover:bg-gray-100 border border-gray-300 focus:ring-gray-500"
    };

    return (
        <button className={clsx(baseClasses, sizeClasses[size], variantClasses[variant], className)} disabled={disabled} {...props}>
            {children}
        </button>
    );
};
